var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAlignCenterVerticalSimple = function SvgIconAlignCenterVerticalSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.25 13v6.5c0 .966.784 1.75 1.75 1.75h6a1.75 1.75 0 0 0 1.75-1.75V13h2.75a1 1 0 1 0 0-2h-2.75V4.5A1.75 1.75 0 0 0 15 2.75H9A1.75 1.75 0 0 0 7.25 4.5V11H4.5a1 1 0 1 0 0 2zm2 6.25h5.5V4.75h-5.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconAlignCenterVerticalSimple;